export const SummaryTextView = ({ summary }: { summary: string }) => {
  return (
    <div className="mt-10 space-y-10 px-1">
      <p className="text-[1.125rem] leading-[1.4] text-eidraBlack">{summary}</p>
    </div>
  );
};
